const baseUrl =
	(import.meta.env.VITE_CONTACT_API_BASE_URL as string | undefined) ||
	(import.meta.env.VITE_API_BASE_URL as string | undefined) ||
	'https://6sxenm4ui7.execute-api.ap-southeast-2.amazonaws.com/dev';

async function http<T>(path: string, options: RequestInit): Promise<T> {
	if (!baseUrl) {
		throw new Error('Contact API URL not configured (VITE_CONTACT_API_BASE_URL or VITE_API_BASE_URL)');
	}
	const res = await fetch(`${baseUrl}${path}`, {
		...options,
		headers: {
			'Content-Type': 'application/json',
			...(options.headers || {})
		}
	});
	const contentType = res.headers.get('content-type') || '';
	try {
		const data = contentType.includes('application/json') ? await res.json() : await res.text();
		if (!res.ok) {
			const msg =
				(typeof (data as any)?.error === 'string' && (data as any).error) ||
				(typeof (data as any)?.message === 'string' && (data as any).message) ||
				(typeof data === 'string' && data) ||
				`Request failed: ${res.status}`;
			throw new Error(msg);
		}
		return data as T;
	} catch (e: any) {
		if (e?.message) throw e;
		throw new Error(`Request failed: ${res.status}`);
	}
}

export type SendContactParams = {
	name: string;
	email: string;
	message: string;
};

export const ContactService = {
	send: (params: SendContactParams) =>
		http<{ ok: boolean; message?: string }>('/contact', {
			method: 'POST',
			body: JSON.stringify(params)
		})
};
